// sortKeyはDBのカラム名と一致させる必要があるため、スネークケースにする

import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { ProjectsArray } from '../types/project/ProjectGetResponse';
import { ProjectPutRequest } from '../types/project/ProjectPutRequest';

export const PROJECT_HEADER = [
  { label: 'PJ No', sortable: true, sortKey: 'project_number', width: '150px' },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  { label: 'クライアント名', sortable: false, sortKey: '', width: '200px' },
  { label: '開始日', sortable: true, sortKey: 'start_date', width: '200px' },
  { label: '終了予定日', sortable: true, sortKey: 'end_date', width: '200px' },
  { label: '非生産', sortable: false, sortKey: '', width: '100px' },
  { label: '大連', sortable: false, sortKey: '', width: '100px' },
  { label: '参画社員管理', sortable: false, sortKey: '', width: '150px' },
  { label: '費用管理', sortable: false, sortKey: '', width: '150px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const PROJECT_MODAL_FIELDS: FieldDescriptor<
  ProjectsArray | ProjectPutRequest
>[] = [
  { label: 'プロジェクトナンバー', key: 'projectNumber', type: 'text' },
  { label: 'プロジェクト名', key: 'projectName', type: 'text' },
  { label: 'クライアント名', key: 'clientName', type: 'text' },
  { label: '開始日', key: 'startDate', type: 'date' },
  { label: '終了予定日', key: 'endDate', type: 'date' },
  { label: '非生産', key: 'isUnproductive', type: 'checkbox' },
  { label: '大連', key: 'isDairen', type: 'checkbox' },
];
